import { updateObject } from "utils/helpers/updateObject";
import { initialState, ReadingMaterialState } from "./state";
import { actionTypes, CreateReadingMaterialFailAction, CreateReadingMaterialRequestAction, CreateReadingMaterialSuccessAction, DeleteReadingMaterialFailAction, DeleteReadingMaterialRequestAction, DeleteReadingMaterialSuccessAction, FetchReadingMaterialsFailureAction, FetchReadingMaterialsRequestAction, FetchReadingMaterialsSuccessAction, ReadingMaterialActions, stateStatusType, UpdateReadingMaterialFailAction, UpdateReadingMaterialRequestAction, UpdateReadingMaterialSuccessAction } from "./actionType";

//FetchReadingMaterialRequest
const FetchReadingMaterialRequest = (
  state: ReadingMaterialState,
  action: FetchReadingMaterialsRequestAction) => {
  return updateObject(state, {
    readingMaterialState: {
      ...state.readingMaterialState,
      isLoading: true,
      error: null,
      status: null,
      delete: null,
    },
  });
};
const FetchReadingMaterialSuccess = (
  state: ReadingMaterialState,
  action: FetchReadingMaterialsSuccessAction) => {
  return updateObject(state, {
    readingMaterialState: {
      ...state.readingMaterialState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      delete: null,
      readingMaterial: action.payload,
    },
  });
};
const FetchReadingMaterialFail = (
  state: ReadingMaterialState,
  action: FetchReadingMaterialsFailureAction) => {
  return updateObject(state, {
    readingMaterialState: {
      ...state.readingMaterialState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
  });
};

//create reading material
const CreateReadingMaterialRequest = (
  state: ReadingMaterialState,
  action:CreateReadingMaterialRequestAction) => {
  return updateObject(state, {
    readingMaterialState: {
      ...state.readingMaterialState,
      isLoading: true,
      error: null,
      status: null,
      delete: null,
    },
  });
};
export const CreateReadingMaterialSuccess = (
  state: ReadingMaterialState,
  action: CreateReadingMaterialSuccessAction
) => {
  return updateObject(state, {
    readingMaterialState: {
      ...state.readingMaterialState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      readingMaterial: action.payload,
      delete: null,
    },
  });
};
const CreateReadingMaterialFail = (
  state: ReadingMaterialState,
  action: CreateReadingMaterialFailAction) => {
  return updateObject(state, {
    readingMaterialState: {
      ...state.readingMaterialState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
      delete: null,
    },
  });
};

//update reading material
const UpdateReadingMaterialRequest = (
  state: ReadingMaterialState,
  action:UpdateReadingMaterialRequestAction) => {
  return updateObject(state, {
    readingMaterialState: {
      ...state.readingMaterialState,
      isLoading: true,
      error: null,
      status: null,
      delete: null,
    },
  });
};
export const UpdateReadingMaterialSuccess = (
  state: ReadingMaterialState,
  action: UpdateReadingMaterialSuccessAction
) => {
  const current = state.readingMaterialState.readingMaterial;
  return updateObject(state, {
    readingMaterialState: {
      ...state.readingMaterialState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      readingMaterial:
        current && current.id === action.payload.id
          ? action.payload
          : current,
      delete: null,
    },
  });
};
const UpdateReadingMaterialFail = (
  state: ReadingMaterialState,
  action: UpdateReadingMaterialFailAction) => {
  return updateObject(state, {
    readingMaterialState: {
      ...state.readingMaterialState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
      delete: null,
    },
  });
};

//delete reading material
const DeleteReadingMaterialRequest = (
  state: ReadingMaterialState,
  action:DeleteReadingMaterialRequestAction) => {
  return updateObject(state, {
    readingMaterialState: {
      ...state.readingMaterialState,
      isLoading: true,
      error: null,
      status: null,
      delete: null,
    },
  });
};
export const DeleteReadingMaterialSuccess = (
  state: ReadingMaterialState,
  action: DeleteReadingMaterialSuccessAction
) => {
  const current = state.readingMaterialState.readingMaterial;

  return updateObject(state, {
    readingMaterialState: {
      ...state.readingMaterialState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      readingMaterial:
        current && String(current.id) === String(action.payload)
          ? null
          : current,
      delete: action.payload,
    },
  });
};
const DeleteReadingMaterialFail = (
  state: ReadingMaterialState,
  action: DeleteReadingMaterialFailAction) => {
  return updateObject(state, {
    readingMaterialState: {
      ...state.readingMaterialState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
      delete: null,
    },
  });
};

const ReadingMaterialReducer = (state = initialState, action: ReadingMaterialActions)=> {
  switch (action.type) {
  case actionTypes.FETCH_READING_MATERIALS_REQUEST:
    return FetchReadingMaterialRequest(state, action);
  case actionTypes.FETCH_READING_MATERIALS_SUCCESS:
    return FetchReadingMaterialSuccess(state, action);
  case actionTypes.FETCH_READING_MATERIALS_FAIL:
    return FetchReadingMaterialFail(state, action);
  case actionTypes.CREATE_READING_MATERIAL_REQUEST:
    return CreateReadingMaterialRequest(state, action);
  case actionTypes.CREATE_READING_MATERIAL_SUCCESS:
    return CreateReadingMaterialSuccess(state, action);
  case actionTypes.CREATE_READING_MATERIAL_FAIL:
    return CreateReadingMaterialFail(state, action);
  case actionTypes.UPDATE_READING_MATERIAL_REQUEST:
    return UpdateReadingMaterialRequest(state, action);
  case actionTypes.UPDATE_READING_MATERIAL_SUCCESS:
    return UpdateReadingMaterialSuccess(state, action);
  case actionTypes.UPDATE_READING_MATERIAL_FAIL:
    return UpdateReadingMaterialFail(state, action);
  case actionTypes.DELETE_READING_MATERIAL_REQUEST:
    return DeleteReadingMaterialRequest(state, action);
  case actionTypes.DELETE_READING_MATERIAL_SUCCESS:
    return DeleteReadingMaterialSuccess(state, action);
  case actionTypes.DELETE_READING_MATERIAL_FAIL:
    return DeleteReadingMaterialFail(state, action);
  default:
    return state;
  }
}

export default ReadingMaterialReducer;
    
